import React from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { useCustomer } from 'lib/core/hooks'
import { PrivateRoute } from 'lib/core/components'
import { CustomerDashboard } from 'scenes/CustomerDashboard'
import { Community } from './scenes/Account/scenes/Community'
import { Impersonate } from 'scenes/CustomerDashboard/scenes/Impersonate'

export const Customer = () => {
  const { customer } = useCustomer()
  // @ts-expect-error
  const isEmployee = customer?.customerType === 1
  return (
    <Switch>
      {isEmployee && (
        <PrivateRoute
          path='/customer/account/community'
          component={Community}
        />
      )}

      <Route
        exact
        path='/customer/account/impersonate/:token'
        component={Impersonate}
      />

      <PrivateRoute
        path='/customer/account/dashboard'
        component={CustomerDashboard}
      />

      <PrivateRoute
        path='/customer/account/addresses'
        component={CustomerDashboard}
      />

      <PrivateRoute
        exact
        path='/customer/account/orders'
        component={CustomerDashboard}
      />

      <PrivateRoute
        path='/customer/account/payment'
        component={CustomerDashboard}
      />

      <PrivateRoute
        path='/customer/account/subscriptions'
        component={CustomerDashboard}
      />

      <PrivateRoute
        exact
        path='/customer/account/wishlist'
        component={CustomerDashboard}
      />

      <PrivateRoute
        exact
        path='/customer/account/about'
        component={CustomerDashboard}
      />

      <Redirect
        to={isEmployee ? '/customer/account/community' : '/customer/account/dashboard'}
      />
    </Switch>
  )
}
